import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { LifebuoyIcon } from '@heroicons/vue/24/outline'
import type { Disaster, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useDisasters(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null
    };

    const wrapper = new ItemWrapper<Disaster>("disasters");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const disasters = ref<Disaster[]>([]);
    const disasterOptions = ref<FormSelectOption[]>([]);

    async function addDisaster(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        disasterOptions.value = disasters.value.map(disaster => {
            return {
                value: disaster.id,
                label: disaster.name,
                icon: LifebuoyIcon
            }
        });
    }

    async function getDisasters(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => disasters.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getDisasters();
    });

    return {
        info,
        request,
        disasters,
        disasterOptions,
        getInfo,
        addDisaster,
        getDisasters
    }
}